module.exports = __webpack_public_path__ + "img/background reserve now.802c0219.jpg";